
import AppModal from '../AppModal'

export default {
  name: 'DayPassModal',
  components: { AppModal },
  props: {
    value: Boolean
  },
  data () {
    return {
      product: {},
      modelValue: this.value
    }
  },
  watch: {
    modelValue () {
      this.$emit('input', this.modelValue)
    },
    value () {
      this.modelValue = this.value
    }
  },
  created () {
    this.$axios.get('v1/payments/music-pass/')
      .then(({ data }) => {
        this.product = data
      })
      .catch(() => {
        // close modal as fallback
        this.$emit('input', false)
      })
  },
  methods: {
    checkout () {
      this.$router.push({
        name: 'dashboard-checkout',
        query: {
          product: this.product.id
        }
      })
    }
  }
}
